import script from "./PropertiesGridView.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertiesGridView.vue?vue&type=script&setup=true&lang=js"

import "./PropertiesGridView.vue?vue&type=style&index=0&id=2b50d464&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b50d464"]])

export default __exports__